import {errorReporter} from 'hudl-base';
window.onerror = errorReporter.sendError;

import 'components/author-profile-page/author-profile-page';
